var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-overlay",
    { attrs: { show: _vm.loading } },
    [
      _c("BatchesFilters", {
        attrs: {
          value: _vm.filters,
          onChange: _vm.onChangeFilters,
          clear: _vm.clearFilters
        }
      }),
      _c(
        "div",
        {
          staticClass:
            "text-left mb-2 d-flex justify-content-start align-items-center"
        },
        [
          _vm.filteredBatches.length
            ? _c(
                "div",
                { staticClass: "my-2 text-primary" },
                [
                  _c("b-form-checkbox", {
                    staticClass: "d-inline-block",
                    on: { change: _vm.selectAllBatches },
                    model: {
                      value: _vm.selectAll,
                      callback: function($$v) {
                        _vm.selectAll = $$v
                      },
                      expression: "selectAll"
                    }
                  }),
                  _vm._v(" Seleccionar todos ")
                ],
                1
              )
            : _vm._e(),
          _c("BatchesOptionsMasive", {
            attrs: { "selected-batches": _vm.selectedBatches }
          }),
          _c(
            "b-button",
            {
              staticClass: "ml-4 badge-glow",
              attrs: { variant: "warning", size: "sm", "data-cy": "download" },
              on: {
                "~click": function($event) {
                  return _vm.onDownloadBatches($event)
                }
              }
            },
            [
              _c("feather-icon", {
                staticClass: "mr-3",
                attrs: { icon: "DownloadIcon" }
              }),
              _c("span", { staticClass: "align-middle" }, [_vm._v("Descargar")])
            ],
            1
          ),
          _vm.view !== "batchs-review"
            ? _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "has-permission",
                      rawName: "v-has-permission",
                      value: "ED165",
                      expression: "'ED165'"
                    }
                  ],
                  staticClass: "badge-glow ml-3",
                  attrs: { variant: "primary", size: "sm", "data-cy": "add" },
                  on: { click: _vm.openBatchForm }
                },
                [
                  _c("feather-icon", {
                    staticClass: "mr-50",
                    attrs: { icon: "list" }
                  }),
                  _c("span", { staticClass: "align-middle" }, [
                    _vm._v("Agregar lote")
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c("BatchesHeader"),
      _c(
        "div",
        { key: _vm.forceRender, staticClass: "force-render" },
        _vm._l(_vm.filteredBatches, function(batch) {
          return _c("BatchesRow", {
            key: batch.loteId,
            attrs: {
              "is-massive": _vm.isMassive,
              "selected-batches": _vm.selectedBatches,
              batch: batch,
              "select-batch": _vm.selectBatch,
              "data-cy": "file"
            },
            on: {
              "select-check-batch": _vm.selectCheckBatch,
              "unselect-check-batch": _vm.unSelectCheckBatch,
              "reload-list": _vm.handleReloadList
            }
          })
        }),
        1
      ),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-3" }, [
          _c("div", { staticClass: "mt-5" }, [
            _vm._v(" Mostrando "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.rowspp,
                    expression: "rowspp"
                  }
                ],
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.rowspp = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    function($event) {
                      return _vm.fetchBatches()
                    }
                  ]
                }
              },
              [
                _c("option", { attrs: { value: "10", selected: "selected" } }, [
                  _vm._v("10 ")
                ]),
                _c("option", { attrs: { value: "15" } }, [_vm._v("15")]),
                _c("option", { attrs: { value: "30" } }, [_vm._v("30")]),
                _c("option", { attrs: { value: "50" } }, [_vm._v("50")])
              ]
            ),
            _vm._v(" registros por página. ")
          ])
        ]),
        _c(
          "div",
          { staticClass: "col-9" },
          [
            _c("BatchesPagination", {
              attrs: { show: _vm.filteredBatches.length },
              model: {
                value: _vm.page,
                callback: function($$v) {
                  _vm.page = $$v
                },
                expression: "page"
              }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }